import * as Yup from 'yup'
import ValidationShema from 'constants/ValidationShema';
import Tr from 'translations/Translations';
import ImputLimits from 'constants/InputLimits';
import {POSITION_TYPE} from "components/popup/addAdditionalPosition/constants/additionalPositionType.values";

const limits = ImputLimits.procedure.parameters;

export default (selectedItems) => Yup.lazy(values => {

	const reg = '^(?!(' + selectedItems.map(x => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')+ ')$).*$';
	const otherNameRegExp = new RegExp(reg)

	let shapeObj = {
		name: ValidationShema.stringExactlyMax(
			otherNameRegExp,
			Tr('v_position_exist'),
			limits.NAME
		)
	}

	if (values.uiType === POSITION_TYPE.YES_NO) {
		shapeObj = {
			...shapeObj,
			showCommentField: ValidationShema.requiredBoolean()
		}
	}

	return Yup.object().shape(shapeObj);
})